<template>
	<div class="panel panel-default" style="padding: 0px; margin: 0px;">
		<div class="panel-heading">
			<h3 class="panel-title">
				<span class="status-accordion" v-on:click="popStatus()"><i class="fa" v-bind:class="{'fa-minus-square-o':obj.selected,'fa-plus-square-o':!obj.selected}"></i>&nbsp;</span>				{{obj.desc}}
			</h3>
		</div>
		<div class="panel-body" v-show="obj.selected">
			<template v-for="item in obj.value">
				<template v-if="item.type=='status'">
					<my-component-status :name="item.desc" :mark="item.mark" :value="item.value" :atm="atm" @changeactive="$emit('statuschange',$event)"></my-component-status>
				</template>
				<template v-if="item.type=='number'">
					<my-component-number :item="item"></my-component-number>
				</template>
				<template v-if="item.type=='select'">
					<my-component-select :item="item"></my-component-select>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['obj', 'atm'],
		data: function () {
			return {
				error: ''
			}
		},
		computed: {},
		methods: {
			popStatus: function () {
				this.obj.selected = !this.obj.selected
			},
		}
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// input-panel.vue?43985d3c